import { useEffect, useState } from 'react';
import { Icon } from '../components/Icon';
import { CallerPhone, type PhoneStatus } from '../lib/caller';

/**
 * Elena's phone (#/caller): carries the voice of the ADMIN LINE calls she makes for you. Usually it runs
 * unseen in headless Chrome on the VPS; opened in a tab it shows what is going on, and with ?listen=1
 * you also hear both sides.
 */
const labels: Record<PhoneStatus['state'], string> = {
  offline: 'Nije povezan sa Elenom',
  ready: 'Spreman za pozive',
  ringing: 'Igraču zvoni',
  talking: 'Razgovor u toku',
};

export function Caller() {
  const [status, setStatus] = useState<PhoneStatus | null>(null);

  useEffect(() => {
    document.title = 'Elena · telefon';
    document.body.classList.add('is-widget');
    const listen = /[?&]listen=1/.test(location.hash);
    const phone = new CallerPhone(setStatus, listen);
    phone.start();
    return () => {
      phone.stop();
      document.body.classList.remove('is-widget');
    };
  }, []);

  const state = status?.state ?? 'offline';
  return (
    <main className="widget" aria-live="polite">
      <header className="widget-head">
        <span className="brand-mark">
          <Icon name="phone" size={20} stroke={2} />
        </span>
        <span className="brand-name">Elenin telefon</span>
        <span className="push row gap-8 small">
          <span
            className={`dot ${state === 'offline' ? 'off' : state === 'ready' ? 'on' : 'warn'}`}
          />
          {labels[state]}
        </span>
      </header>
      <section className="widget-body">
        {status?.player && <p className="console-user">{status.player}</p>}
        {status?.lastSaid && <p className="widget-reply">{status.lastSaid}</p>}
        {status?.lastHeard && <p className="muted small">Igrač: „{status.lastHeard}“</p>}
        {status?.error && <p className="notice">{status.error}</p>}
        {state === 'ready' && !status?.error && (
          <p className="muted small">
            Ovde Elena priča sa igračima kad u admin panelu pritisneš ELENA. Ostavi ovu stranicu
            otvorenu (ili je pokreni na VPS-u kao servis „caller“).
          </p>
        )}
      </section>
    </main>
  );
}
